export const formatError = (message: string) => {
  return `🧬 [Helix]: ${message}`;
};
